module.exports = __webpack_public_path__ + "img/HE7301-01.a6fbaeaf.jpg";